import './styles.scss'

import React, { memo } from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const ReputationData = ({ data, showChecks }) => {
  if (!data || data.error) {
    return null
  }

  const check = showChecks ? 'check' : 'no-check'

  return (
    <ul className='biguserinfo in-react reputation-data'>
      <li className='member'>
        <div className={check}>
          {data.isTeacher
            ? I18n.t('profiles.profile_layout.teacher_since', { day: data.memberSince })
            : I18n.t('profiles.profile_layout.member_since', { day: data.memberSince })}
        </div>
      </li>

      {!!data.repeatStudentCount && (
        <li className='repeat'>
          <div className={check}>
            {I18n.t('profiles.profile_layout.repeat_students', { count: data.repeatStudentCount })}
          </div>
        </li>
      )}

      {data.phoneVerified && (
        <li className='phone'>
          <div className={check}>{I18n.t('profiles.profile_layout.phone_verified')}</div>
        </li>
      )}

      {data.socialFacebook && (
        <li className={`facebook ${data.socialFacebookCount ? 'twoline' : ''}`}>
          <div className={check}>
            {I18n.t('profiles.profile_layout.verified_facebook')}
            {data.socialFacebookCount && (
              <div className='subinfo'>
                {I18n.t('profiles.show_right.facebook_friends', { count: data.socialFacebookCount })}
              </div>
            )}
          </div>
        </li>
      )}

      {data.socialGoogle && (
        <li className='google'>
          <div className={check}>{I18n.t('profiles.profile_layout.verified_google')}</div>
        </li>
      )}

      {data.socialLinkedIn && (
        <li className={`linkedin ${data.socialLinkedInCount ? 'twoline' : ''}`}>
          <div className={check}>
            {I18n.t('profiles.profile_layout.verified_linkedin')}
            {data.socialLinkedInCount && (
              <div className='subinfo'>
                {I18n.t('profiles.show_right.linkedin_connections', { count: data.socialLinkedInCount })}
              </div>
            )}
          </div>
        </li>
      )}

      {data.socialTwitter && (
        <li className='twitter'>
          <div className={check}>{I18n.t('profiles.profile_layout.verified_twitter')}</div>
        </li>
      )}
    </ul>
  )
}

ReputationData.propTypes = {
  data: PropTypes.object,
  showChecks: PropTypes.bool
}

export default memo(ReputationData, (prevProps, nextProps) => prevProps.data === nextProps.data)
